"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_SOURCE_TYPE_VALUES = void 0;
exports.IMAGE_SOURCE_TYPE_VALUES = [
    'CREATIVE_ASSET',
    'USER_UPLOAD',
    'CLIENT_WEBSITE',
    'CUSTOMER_REVIEW_USER',
];
